{
  "yourAssets": "Deine Anlagen",
  "yourAssetsOn": "Deine Anlagen am",
  "setDate": "Datum für diese Ansicht wählen",
  "edit": "Anpassen",
  "share": "Teilen",
  "done": "Anpassen beenden",
  "pleaseWait": "Bitte warten, wir bereiten die Daten vor...",
  "externalSync": "Banken senden noch Daten (bis zu 60s)...",
  "postFile": {
    "header": "Welches Konto?",
    "prompt": "Bitte wähle das Konto aus, zu dem du die Datei gehört."
  },
  "shareReport": {
    "header": "Dashboard teilen",
    "tooltip": "Wir erstellen einen Link, den du mit anderen teilen kannst. Für extra Sicherheit, setze jetzt ein Passcode, mit dem der Link geschützt wird.",
    "next": "Weiter",
    "confirmation": {
      "copy": "Kopieren",
      "copyBoth": "Schicke Link und Passcode an den Empfänger. Er(sie) sieht das Dashboard mit heutigen Daten.",
      "securityHint": "Wenn möglich, schicke die beiden Codes über verschiedene Kanäle (z.B. Email und Chat)."
    }
  },
  "sharedReportViewer": {
    "header": "Passcode",
    "prompt": "Bitte gib den Passcode ein, um das Dashboard zu sehen.",
    "reportNotFound": "Dashboard nicht gefunden",
    "unableToLoadReport": "Das Dashboard kann nicht geladen werden. Bitte überprüfe den Passcode."
  },
  "categories": {
    "deposits": "Bankkonten",
    "stocks": "Depots",
    "pension": "Rentenprodukte",
    "realEstate": "Immobilien",
    "objectsOfValue": "Wertobjekte",
    "metals": "Edelmetalle",
    "loans": "Darlehen",
    "unlistedShares": "Private Unternehmen",
    "crypto": "Kryptowährungen"
  },
  "singleCategory": {
    "deposits": "Bankkonto",
    "stocks": "Depot",
    "pension": "Rentenanlage",
    "realEstate": "Immobilie",
    "objectsOfValue": "Wertobjekt",
    "metals": "Edelmetall",
    "loans": "Darlehen",
    "unlistedShares": "Privates Unternehmen",
    "crypto": "Kryptowährung"
  },
  "sumtile": {
    "change": "Änderung gegenüber dem Basisdatum.",
    "warning": "Es gibt Unstimmigkeiten in deinen Daten, die sich auf diese Zahl auswirken können. Klicke hier, um Details anzuzeigen.",
    "inconsistent": "Unstimmigkeiten",
    "orphanedDialog": {
      "assetTransactionsDialogTitle": "Transaktionen für Vermögenswerte ohne Einzahlungstransaktionen",
      "netWorthExplanation": "Um deinen Nettowert und dessen Änderungen korrekt zu berechnen, muss jeder Verkauf von Vermögenswerten mit einer Transaktion auf einem Bank- oder Bar-Konto verknüpft sein. Die entsprechende Banktransaktion muss dazu getaggt werden.",
      "notLinkedTransactionsExplanation": "Die folgenden Transaktionen sind keiner Einzahlungstransaktion zugeordnet. Klicke eine, um zum entsprechenden Bankkonto weitergeleitet zu werden, und tagge dort die passende Transaktion.",
      "transactionTableHeaders": {
        "date": "Datum",
        "assetAccount": "Vermögenskonto",
        "assetName": "Vermögenswert",
        "amount": "Betrag",
        "price": "Wert"
      },
      "closeButtonText": "Schließen"
    },
    "generalIncome": {
      "label": "Allgemeine Einnahmen",
      "tooltip": "Einkommen aus externen Quellen, z.B. Beschäftigung."
    },
    "incomeFromCapital": {
      "label": "Kapitaleinkommen",
      "tooltip": "Kapitaleinkommen erzielt seit dem Basisdatum - aus z.B. Dividenden oder Erträgen von Verkaufen von Aktien sowie weiteren Investitionen. Blauer Kreis neben einer Transaktion bedeutet, dass sie zu dieser Kategorie gehört."
    },
    "assetValueIncrease": {
      "label": "Änderung des Anlagenwerts",
      "tooltip": "Zeigt, wie sich seit Basisdatum der Wert aller Anlagen (Aktien, Immobilien etc.) geändert hat."
    },
    "outflows": {
      "label": "Allgemeine Ausgaben",
      "tooltip": "Ausgaben, die nicht mit Investitionen zusammenhängen, wie z.B. Miete, Nebenkosten, Einkäufe. gehören zu dieser Kategorie. Käufe von Aktien und Investitionen gehören hierzu nicht."
    },
    "previousValue": {
      "label": "Vermögen am Basisdatum",
      "tooltip": "Gesamtwert aller Anlagen und Konten am unten gewählten Basisdatum.",
      "selectBaseline": "Basisdatum wählen:",
      "sameTimeLastYear": "Gleicher Tag letztes Jahr",
      "beginning": "Anfang des Jahres",
      "beginningLastYear": "Anfang des Vorjahres",
      "custom": "Frei wählbar"
    },
    "changeInValue": {
      "label": "Wertänderung",
      "tooltip": "Wertänderung aller Anlagen und Konten zwischen dem Basisdatum und heute."
    },
    "currentNetWorth": {
      "label": "Aktuelles Vermögen",
      "tooltip": "Wert deines gesamten Vermögens mit Abzug aller Schulden."
    }
  }
}
